import React, { useState } from 'react';
import { VacancySearchModal } from './VacancySearchModal';

export function SidebarSearch() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="px-5 py-4">
        <div
          data-testid="sidebar-search-trigger"
          className="flex items-center gap-2 text-[var(--text-dark)] cursor-pointer hover:opacity-70 transition-opacity"
          onClick={() => setIsModalOpen(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setIsModalOpen(true);
            }
          }}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M11 11L14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          <span data-testid="sidebar-search-label" className="text-[14px] font-medium">Поиск по вакансиям</span>
        </div>
      </div>

      <VacancySearchModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
}
